import { PitchFormation, TacticalSlot } from "@/generated/graphql";

/** R01-J layouts: attack first, goalkeeper last; slots preserve lateral order. */
export const PITCH_FORMATION_ROWS: Record<
  PitchFormation,
  readonly (readonly TacticalSlot[])[]
> = {
  [PitchFormation.F_334]: [
    [TacticalSlot.Lw, TacticalSlot.Lst, TacticalSlot.Rst, TacticalSlot.Rw],
    [TacticalSlot.Lcm, TacticalSlot.Cm, TacticalSlot.Rcm],
    [TacticalSlot.Lcb, TacticalSlot.Cb, TacticalSlot.Rcb],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_343]: [
    [TacticalSlot.Lw, TacticalSlot.St, TacticalSlot.Rw],
    [TacticalSlot.Lm, TacticalSlot.Lcm, TacticalSlot.Rcm, TacticalSlot.Rm],
    [TacticalSlot.Lcb, TacticalSlot.Cb, TacticalSlot.Rcb],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_352]: [
    [TacticalSlot.Lst, TacticalSlot.Rst],
    [
      TacticalSlot.Lm,
      TacticalSlot.Lcm,
      TacticalSlot.Cm,
      TacticalSlot.Rcm,
      TacticalSlot.Rm,
    ],
    [TacticalSlot.Lcb, TacticalSlot.Cb, TacticalSlot.Rcb],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_424]: [
    [TacticalSlot.Lw, TacticalSlot.Lst, TacticalSlot.Rst, TacticalSlot.Rw],
    [TacticalSlot.Lcdm, TacticalSlot.Rcdm],
    [TacticalSlot.Lb, TacticalSlot.Lcb, TacticalSlot.Rcb, TacticalSlot.Rb],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_433]: [
    [TacticalSlot.Lw, TacticalSlot.St, TacticalSlot.Rw],
    [TacticalSlot.Lcm, TacticalSlot.Cm, TacticalSlot.Rcm],
    [TacticalSlot.Lb, TacticalSlot.Lcb, TacticalSlot.Rcb, TacticalSlot.Rb],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_442]: [
    [TacticalSlot.Lst, TacticalSlot.Rst],
    [TacticalSlot.Lm, TacticalSlot.Lcm, TacticalSlot.Rcm, TacticalSlot.Rm],
    [TacticalSlot.Lb, TacticalSlot.Lcb, TacticalSlot.Rcb, TacticalSlot.Rb],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_451]: [
    [TacticalSlot.St],
    [
      TacticalSlot.Lm,
      TacticalSlot.Lcm,
      TacticalSlot.Cm,
      TacticalSlot.Rcm,
      TacticalSlot.Rm,
    ],
    [TacticalSlot.Lb, TacticalSlot.Lcb, TacticalSlot.Rcb, TacticalSlot.Rb],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_532]: [
    [TacticalSlot.Lst, TacticalSlot.Rst],
    [TacticalSlot.Lcm, TacticalSlot.Cm, TacticalSlot.Rcm],
    [
      TacticalSlot.Lb,
      TacticalSlot.Lcb,
      TacticalSlot.Cb,
      TacticalSlot.Rcb,
      TacticalSlot.Rb,
    ],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_541]: [
    [TacticalSlot.St],
    [TacticalSlot.Lm, TacticalSlot.Lcm, TacticalSlot.Rcm, TacticalSlot.Rm],
    [
      TacticalSlot.Lb,
      TacticalSlot.Lcb,
      TacticalSlot.Cb,
      TacticalSlot.Rcb,
      TacticalSlot.Rb,
    ],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_3412]: [
    [TacticalSlot.Lst, TacticalSlot.Rst],
    [TacticalSlot.Cam],
    [TacticalSlot.Lm, TacticalSlot.Lcm, TacticalSlot.Rcm, TacticalSlot.Rm],
    [TacticalSlot.Lcb, TacticalSlot.Cb, TacticalSlot.Rcb],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_4123]: [
    [TacticalSlot.Lw, TacticalSlot.St, TacticalSlot.Rw],
    [TacticalSlot.Lcm, TacticalSlot.Rcm],
    [TacticalSlot.Cdm],
    [TacticalSlot.Lb, TacticalSlot.Lcb, TacticalSlot.Rcb, TacticalSlot.Rb],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_4132]: [
    [TacticalSlot.Lst, TacticalSlot.Rst],
    [TacticalSlot.Lm, TacticalSlot.Cm, TacticalSlot.Rm],
    [TacticalSlot.Cdm],
    [TacticalSlot.Lb, TacticalSlot.Lcb, TacticalSlot.Rcb, TacticalSlot.Rb],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_4213]: [
    [TacticalSlot.Lw, TacticalSlot.St, TacticalSlot.Rw],
    [TacticalSlot.Cam],
    [TacticalSlot.Lcdm, TacticalSlot.Rcdm],
    [TacticalSlot.Lb, TacticalSlot.Lcb, TacticalSlot.Rcb, TacticalSlot.Rb],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_4222]: [
    [TacticalSlot.Lst, TacticalSlot.Rst],
    [TacticalSlot.Lam, TacticalSlot.Ram],
    [TacticalSlot.Lcdm, TacticalSlot.Rcdm],
    [TacticalSlot.Lb, TacticalSlot.Lcb, TacticalSlot.Rcb, TacticalSlot.Rb],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_4231]: [
    [TacticalSlot.St],
    [TacticalSlot.Lw, TacticalSlot.Cam, TacticalSlot.Rw],
    [TacticalSlot.Lcdm, TacticalSlot.Rcdm],
    [TacticalSlot.Lb, TacticalSlot.Lcb, TacticalSlot.Rcb, TacticalSlot.Rb],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_4312]: [
    [TacticalSlot.Lst, TacticalSlot.Rst],
    [TacticalSlot.Cam],
    [TacticalSlot.Lcm, TacticalSlot.Cm, TacticalSlot.Rcm],
    [TacticalSlot.Lb, TacticalSlot.Lcb, TacticalSlot.Rcb, TacticalSlot.Rb],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_4321]: [
    [TacticalSlot.St],
    [TacticalSlot.Lam, TacticalSlot.Ram],
    [TacticalSlot.Lcm, TacticalSlot.Cm, TacticalSlot.Rcm],
    [TacticalSlot.Lb, TacticalSlot.Lcb, TacticalSlot.Rcb, TacticalSlot.Rb],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_4411]: [
    [TacticalSlot.St],
    [TacticalSlot.Cam],
    [TacticalSlot.Lm, TacticalSlot.Lcm, TacticalSlot.Rcm, TacticalSlot.Rm],
    [TacticalSlot.Lb, TacticalSlot.Lcb, TacticalSlot.Rcb, TacticalSlot.Rb],
    [TacticalSlot.Gk],
  ],
  [PitchFormation.F_5221]: [
    [TacticalSlot.St],
    [TacticalSlot.Lam, TacticalSlot.Ram],
    [TacticalSlot.Lcdm, TacticalSlot.Rcdm],
    [
      TacticalSlot.Lb,
      TacticalSlot.Lcb,
      TacticalSlot.Cb,
      TacticalSlot.Rcb,
      TacticalSlot.Rb,
    ],
    [TacticalSlot.Gk],
  ],
};
